(function(angular) {
	'use strict';
	/**
	 * Add directives to the audit module
	 */
	var core = angular.module('Core');
	/*
	 * Extended form
	 *
	 * commands: {
	 *	applyData: Data are saved internally in the form and the dirty flag is set to false,
	 *	setDirty: Set dirty the global form
	 * }
	 */
	core.directive('stlUpload', function ($timeout, $translate, LoaderService, NotificationService) {
		/**
		 * Gives auto submit with form without any input type = sumbit
		 */
		return {
			restrict: 'E',
			scope: {
				uploadAction: '=',
				buttonText: '=',
				uploadDisabled: '=',
				onSuccess: '&',
				fileTypes: '@',
				successMessageKey: '@',
				errorMessageKey: '@',
				fileNotAllowedMessageKey: '@',
				dropZone: '@',
				beforeUpload: '=?',
				parameters: '=?'
			},
			replace: true,
			templateUrl: 'components/core/form/upload/upload.html',
			transclude: true,
			link: function (scope, element, attrs) {
				var types = [];
				if (scope.fileTypes) {
					var ts = scope.fileTypes.split(',');
					for (var i = 0; i < ts.length; i++) {
						types.push(ts[i]);
					}
				}
				scope.options = {
					autoUpload: !scope.beforeUpload
				};
				var hasDropZone = false;
				if (scope.dropZone && scope.dropZone !== '') {
					scope.options.dropZone = $(scope.dropZone);
					hasDropZone = true;
				}

				var isAllowed = function (filename) {
					var allowed = false;
					var fn = filename.toUpperCase();
					if (types.length > 0) {
						for (var j = 0; j < types.length; j++) {
							var t = types[j].toUpperCase();
							allowed = fn.indexOf(t, fn.length - t.length) !== -1;
							if (allowed === true) {
								break;
							}
						}
					}
					return allowed;
				};

				$(element).bind('fileuploadadd', function(e, data) {

					var files = data.files;
					var err = false;
					var notificationFn = function() {
						NotificationService.notify('INFO', $translate.instant(scope.fileNotAllowedMessageKey));
					};

					for (var j = 0; j < files.length; j++) {
						var f = files[j];
						if (!isAllowed(f.name)) {
							err = true;
							e.preventDefault();
							$timeout(notificationFn);
						}
					}
					if (!err && scope.beforeUpload) {
						scope.beforeUpload(scope.parameters).then(function() {
							data.submit();
						});
					}

				});
				$(element).bind('fileuploadsubmit', function (e, data) {
					// Submitting... let's show the loader
					LoaderService.show();
				});
				$(element).bind('fileuploaddone', function (e, data) {
					// Submitting... let's show the loader
					LoaderService.hide();
					$timeout(function () {
						NotificationService.notify('SUCCESS', $translate.instant(scope.successMessageKey));
						if (scope.onSuccess) {
							scope.onSuccess();
						}
					});

				});
				$(element).bind('fileuploadfail', function (e, data) {
					$timeout(function () {
						// Submitting... let's show the loader
						LoaderService.hide();
						if (data.result && data.result.httpStatus) {

							NotificationService.showApplicationErrorMessage(
									data.result.httpStatus, scope.uploadAction, data.result);
						} else {
							NotificationService.notify('ERROR', $translate.instant(scope.errorMessageKey));
						}
					});
				});

				// Remove event handlers on destroy
				scope.$on('$destroy', function () {
					$(element).unbind('fileuploadsubmit');
					$(element).unbind('fileuploaddone');
					$(element).unbind('fileuploadfail');

					if (hasDropZone) {
						$(scope.dropZone).unbind('dragover');
					}
				});

				var dropzoneEnabled = false;
				if (hasDropZone && (GLOBALVARS.browser.type !== 'ie' || GLOBALVARS.browser.version > 9)) {
					dropzoneEnabled = true;
				}

				var timeoutDropZone = null;

				if (dropzoneEnabled) {
					$(document).bind('dragover', function(e) {
						if (scope.uploadDisabled === true) {
							return;
						}
						var dropZone = $(scope.dropZone);
						if (!timeoutDropZone) {
							dropZone.addClass('in');
							dropZone.css('display', 'block');
						} else {
							clearTimeout(timeoutDropZone);
						}
						var found = false, node = e.target;
						do {
							if (node === dropZone[0]) {
								found = true;
								break;
							}
							node = node.parentNode;
						} while (node !== null);
						if (found) {
							dropZone.addClass('hover');
						} else {
							dropZone.removeClass('hover');
						}

						timeoutDropZone = setTimeout(function() {
							timeoutDropZone = null;
							dropZone.removeClass('in hover');
							dropZone.css('display', 'none');
						}, 100);
					});
				}
			}
		};
	});

    core.directive('fileModel', ['$parse', function ($parse) {
        return {
            restrict: 'A',
            link: function(scope, element, attrs) {
                var model = $parse(attrs.fileModel);
                var modelSetter = model.assign;

                element.bind('change', function(){
                    scope.$apply(function(){
                        modelSetter(scope, element[0].files[0]);
                    });
                });
            }
        };
    }]);

})(angular);
